import * as React from "react";

export type SortObject = {
    unsorted: boolean;
    sorted: boolean;
    empty: boolean;
};

export type Pageable = {
    page: number; // минимум: 0
    size: number; // минимум: 1
    sort: string; // там почему-то массив
};

export type PageableObject = {
    unpaged: boolean;
    paged: boolean;
    pageSize: number;
    pageNumber: number;
    offset: number;
    sort: SortObject;
};


export type Page<T> = {
    totalElements: number;
    totalPages: number;
    first: boolean;
    last: boolean;
    size: number;
    content: [T];
    number: number;
    sort: {
        empty: boolean;
        unsorted: boolean;
        sorted: boolean;
    };
    numberOfElements: number;
    pageable: {
        offset: number;
        sort: {
            empty: boolean;
            unsorted: boolean;
            sorted: boolean;
        };
        unpaged: boolean;
        paged: boolean;
        pageNumber: number;
        pageSize: number;
    };
    empty: boolean;
};

export const getDefaultPageable = (): Pageable => {
    return { page: 0, size: 50, sort: "id,asc" };
};